import { render, staticRenderFns } from "./singlePlan.vue?vue&type=template&id=547d74e5&scoped=true&"
import script from "./singlePlan.vue?vue&type=script&lang=js&"
export * from "./singlePlan.vue?vue&type=script&lang=js&"
import style0 from "./singlePlan.vue?vue&type=style&index=0&id=547d74e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d74e5",
  null
  
)

export default component.exports